/**
 * GlobalFilters - Componente de Filtros Globais para Dashboard Inside Sales
 * Permite filtrar dashboards por ano e mês
 */
import React from "react";
import { Card, Form, Row, Col } from "react-bootstrap";
import { FiFilter } from "react-icons/fi";

const GlobalFilters = ({ filters, onFiltersChange }) => {
  // Meses do ano
  const months = [
    { value: null, label: "Todos os meses" },
    { value: 1, label: "Janeiro" },
    { value: 2, label: "Fevereiro" },
    { value: 3, label: "Março" },
    { value: 4, label: "Abril" },
    { value: 5, label: "Maio" },
    { value: 6, label: "Junho" },
    { value: 7, label: "Julho" },
    { value: 8, label: "Agosto" },
    { value: 9, label: "Setembro" },
    { value: 10, label: "Outubro" },
    { value: 11, label: "Novembro" },
    { value: 12, label: "Dezembro" },
  ];

  const years = Array.from(
    { length: new Date().getFullYear() + 1 - 2015 + 1 },
    (_, index) => new Date().getFullYear() + 1 - index
  );

  const handleYearChange = (e) => {
    const year = parseInt(e.target.value);
    onFiltersChange({ ...filters, year });
  };

  const handleMonthChange = (e) => {
    const month = e.target.value === "" ? null : parseInt(e.target.value);
    onFiltersChange({ ...filters, month });
  };

  const selectedMonthLabel = months.find((m) => m.value === filters.month)?.label;

  return (
    <Card className="mb-4 border-0 shadow-sm">
      <Card.Body className="p-3">
        <Row className="align-items-center">
          <Col xs="auto">
            <div className="d-flex align-items-center">
              <FiFilter className="text-primary me-2" size={20} />
              <h6 className="mb-0 fw-bold text-dark">Filtros Globais</h6>
            </div>
          </Col>
          <Col xs={12} md="auto" className="mt-3 mt-md-0">
            <Form.Group className="mb-0">
              <Form.Label className="mb-1 small text-muted">Ano</Form.Label>
              <Form.Select
                value={filters.year}
                onChange={handleYearChange}
                size="sm"
                style={{ width: "86px" }}
              >
                {years.map((year) => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col xs={12} md="auto" className="mt-3 mt-md-0">
            <Form.Group className="mb-0">
              <Form.Label className="mb-1 small text-muted">Mês</Form.Label>
              <Form.Select
                value={filters.month === null ? "" : filters.month}
                onChange={handleMonthChange}
                size="sm"
                style={{ minWidth: "220px" }}
              >
                {months.map((month) => (
                  <option key={month.label} value={month.value === null ? "" : month.value}>
                    {month.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <div
          className="mt-3 px-3 py-2 rounded-2 border d-inline-block"
          style={{ backgroundColor: "#e8f4ff", borderColor: "#b6dcff", maxWidth: "100%" }}
        >
          <span className="fw-semibold text-primary">
            {filters.month !== null
              ? `Filtro ativo: ${selectedMonthLabel} de ${filters.year}`
              : `Filtro ativo: Todos os meses de ${filters.year}`}
          </span>
        </div>
      </Card.Body>
    </Card>
  );
};

export default GlobalFilters;
